export interface TickerItem {
  id: number;
  time: string;
  text: string;
}

export const tickerItems: TickerItem[] = [
  { id: 1, time: "12:40", text: "「夜航船阿泽」直播间突发口播事故，团队凌晨两点发布文字回应" },
  { id: 2, time: "11:25", text: "「甜心苏打」带货数据被质疑注水，品牌方悄悄下架联名款" },
  { id: 3, time: "10:08", text: "「冷面阿哲」小号被限制推荐，主页作品批量转为仅粉丝可见" },
  { id: 4, time: "09:36", text: "「桃子不吃桃」与「一只椰子」粉丝互相刷屏，话题冲上热榜" },
  { id: 5, time: "08:52", text: "「咸鱼小满」前运营爆料分成纠纷，双方各执一词待核实" },
  { id: 6, time: "08:15", text: "「大熊拆机」对比视频被扒出时间轴错位，原片已下架" },
  { id: 7, time: "07:40", text: "「楠风摄影」联名周边被指货不对版，客服通道一度拥挤" },
  { id: 8, time: "06:58", text: "「铁头阿强」就训练营夸大宣传发布长文致歉，承诺全额退费" },
];

export interface FeedItem {
  id: number;
  bucket: "最新" | "热议" | "实锤";
  time: string;
  tag: string;
  title: string;
  summary: string;
  views: string;
  comments: string;
}

export const feedItems: FeedItem[] = [
  {
    id: 1,
    bucket: "最新",
    time: "12:40",
    tag: "直播事故",
    title: "「夜航船阿泽」直播间突发口播事故，团队凌晨两点紧急回应",
    summary:
      "连麦环节中的一句口误被剪成短视频整晚疯传，直播间在线人数十分钟翻了三倍。团队于凌晨发布文字说明，但未就是否调整排班给出结论，评论区仍在等后续。",
    views: "48.2万",
    comments: "1,204",
  },
  {
    id: 2,
    bucket: "最新",
    time: "11:25",
    tag: "数据注水",
    title: "「甜心苏打」带货数据被质疑注水，品牌方悄悄下架联名",
    summary:
      "第三方拆解显示其专场观看时长与成交转化曲线异常贴合，网友顺手对比了三场直播的重复下单占比。品牌方未发声明，联名链接已从前台撤下。",
    views: "36.7万",
    comments: "968",
  },
  {
    id: 3,
    bucket: "最新",
    time: "10:08",
    tag: "账号封禁",
    title: "「冷面阿哲」小号被限制推荐，主页作品批量转为仅粉丝可见",
    summary:
      "有粉丝发现其矩阵小号已无法被搜索，主页排序作品统一变成仅粉丝可见。目前没有平台公告，团队客服只回复「以系统通知为准」。",
    views: "22.4万",
    comments: "612",
  },
  {
    id: 4,
    bucket: "热议",
    time: "09:36",
    tag: "粉丝互撕",
    title: "「桃子不吃桃」与「一只椰子」粉丝互相刷屏，话题冲上热榜",
    summary:
      "起因是一条疑似内涵文案，两家粉丝开始在对方评论区接力刷屏，随后演变成对往期合作片段的逐帧解读。两位当事人目前均未表态。",
    views: "61.3万",
    comments: "2,318",
  },
  {
    id: 5,
    bucket: "热议",
    time: "08:52",
    tag: "团队内讧",
    title: "「咸鱼小满」前运营爆料分成纠纷，双方各执一词",
    summary:
      "前运营放出一段聊天记录截图，称合作期间分成口径多次变更；本人回应「合同白纸黑字，欢迎走流程」。双方都表示已交给法务。",
    views: "44.9万",
    comments: "1,507",
  },
  {
    id: 6,
    bucket: "热议",
    time: "07:20",
    tag: "言论争议",
    title: "「老K说车」测评用词引争议，同行接连下场回应",
    summary:
      "一句对竞品的点评被解读为拉踩，随后多位车评博主加入讨论。原视频播放量一夜涨了百万，但合集的弹幕已经开始跑偏。",
    views: "53.1万",
    comments: "1,842",
  },
  {
    id: 7,
    bucket: "实锤",
    time: "06:15",
    tag: "剪辑造假",
    title: "「大熊拆机」对比视频被扒出时间轴错位，原片已下架",
    summary:
      "网友逐帧比对后指出两段画面对应的是不同批次样机，时间轴存在错位。账号已下架原视频并置顶说明，称「素材管理失误」。",
    views: "39.6万",
    comments: "1,133",
  },
  {
    id: 8,
    bucket: "实锤",
    time: "昨天",
    tag: "联名翻车",
    title: "「楠风摄影」联名周边被指货不对版，客服通道一度拥挤",
    summary:
      "收到实物的用户晒出对比图，称印刷色差与样品明显不符。工作室回应为批次差异并开放换货，但排队人数一度超过五位数。",
    views: "28.8万",
    comments: "874",
  },
  {
    id: 9,
    bucket: "实锤",
    time: "昨天",
    tag: "深夜致歉",
    title: "「铁头阿强」就训练营夸大宣传发布长文致歉，承诺全额退费",
    summary:
      "长文中承认课程页面的部分数据引用不严谨，并给出退费与补偿方案。评论区一半在等细则，一半在翻旧账。",
    views: "31.2万",
    comments: "1,046",
  },
];

export interface FeaturedEvent {
  id: number;
  size: "large" | "small";
  tag: string;
  title: string;
  summary: string;
  image: string;
  source: string;
  time: string;
  stat: string;
}

export const featuredEvents: FeaturedEvent[] = [
  {
    id: 1,
    size: "large",
    tag: "本周头号实锤",
    title: "一场直播、四个版本：把「夜航船阿泽」口播事故的时间线捋清楚",
    summary:
      "从当晚直播切片到凌晨声明，我们按公开可见的素材把节点重新排了一遍，哪些是关键证据、哪些还只是猜测，一张图看完。",
    image:
      "https://readdy.ai/api/search-image?query=Moody%20close-up%20editorial%20photograph%20of%20a%20smartphone%20screen%20glowing%20on%20a%20dark%20textured%20desk%20amid%20scattered%20printed%20documents%20and%20a%20cold%20coffee%20cup%2C%20warm%20amber%20desk%20lamp%20light%20from%20the%20side%2C%20blurred%20charcoal%20background%2C%20investigative%20archive%20mood%2C%20subtle%20film%20grain%2C%20no%20readable%20text%2C%20no%20people%2C%20high%20detail&width=1000&height=1000&seq=hll-feature-large-01&orientation=squarish",
    source: "事件档案 · 整理组",
    time: "2 小时前",
    stat: "4.8万 人已读",
  },
  {
    id: 2,
    size: "small",
    tag: "直播事故",
    title: "导播切换与口播稿对不上，控制室视角的十分钟",
    summary: "多机位素材比对后，事故窗口比想象中更短。",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20an%20abandoned%20broadcast%20control%20room%2C%20rows%20of%20darkened%20monitor%20screens%20with%20faint%20warm%20reflections%2C%20tangled%20cables%2C%20empty%20chair%2C%20muted%20charcoal%20and%20amber%20tones%2C%20soft%20haze%2C%20no%20people%2C%20no%20readable%20text%2C%20subtle%20film%20grain%2C%20clean%20minimalist%20composition&width=600&height=450&seq=hll-feature-02&orientation=landscape",
    source: "热榜讨论",
    time: "3 小时前",
    stat: "1.9万 讨论",
  },
  {
    id: 3,
    size: "small",
    tag: "数据注水",
    title: "把三场专场的成交曲线叠在一起，问题就出来了",
    summary: "重复下单占比与观看时长，是最直观的两条线。",
    image:
      "https://readdy.ai/api/search-image?query=Clean%20editorial%20still%20life%20of%20stacked%20bar-chart%20shaped%20wooden%20blocks%20and%20a%20magnifying%20glass%20on%20a%20pale%20warm%20paper%20background%2C%20soft%20natural%20side%20light%2C%20muted%20earthy%20palette%2C%20minimal%20composition%2C%20subtle%20soft%20shadows%2C%20no%20text%2C%20no%20people%2C%20high%20detail&width=600&height=450&seq=hll-feature-03&orientation=landscape",
    source: "数据观察",
    time: "5 小时前",
    stat: "1.2万 人已读",
  },
  {
    id: 4,
    size: "small",
    tag: "品牌动作",
    title: "联名被撤下前后，品牌方的三次沉默",
    summary: "从下架链接到关闭评论区，时间点都值得记一笔。",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20crumpled%20contract%20page%20and%20a%20broken%20wax%20seal%20on%20a%20warm%20wooden%20table%2C%20soft%20window%20light%2C%20muted%20cream%20and%20charcoal%20tones%2C%20shallow%20depth%20of%20field%2C%20investigation%20mood%2C%20no%20readable%20text%2C%20no%20people%2C%20subtle%20grain&width=600&height=450&seq=hll-feature-04&orientation=landscape",
    source: "事件档案 · 整理组",
    time: "8 小时前",
    stat: "9,640 人已读",
  },
  {
    id: 5,
    size: "small",
    tag: "回应观察",
    title: "道歉长文里没说的部分，往往比说了的更重要",
    summary: "我们对比了三次回应，口径变化一目了然。",
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20an%20empty%20press%20conference%20podium%20with%20a%20single%20microphone%20against%20a%20plain%20warm%20beige%20backdrop%2C%20soft%20directional%20lighting%2C%20muted%20palette%2C%20minimal%20clean%20composition%2C%20no%20text%2C%20no%20people%2C%20subtle%20film%20grain%2C%20high%20detail&width=600&height=450&seq=hll-feature-05&orientation=landscape",
    source: "热榜讨论",
    time: "昨天",
    stat: "1.5万 讨论",
  },
];

export interface CategoryItem {
  id: number;
  name: string;
  icon: string;
  count: string;
  desc: string;
}

export const categories: CategoryItem[] = [
  { id: 1, name: "直播口播事故", icon: "ri-mic-line", count: "1,284", desc: "连麦、口误、临时救场" },
  { id: 2, name: "虚假宣称", icon: "ri-alert-line", count: "968", desc: "夸大宣传与话术争议" },
  { id: 3, name: "数据注水", icon: "ri-bar-chart-2-line", count: "742", desc: "成交、涨粉与互动异常" },
  { id: 4, name: "粉丝互撕", icon: "ri-chat-smile-2-line", count: "1,530", desc: "团战、刷屏与内涵文案" },
  { id: 5, name: "账号封禁", icon: "ri-forbid-2-line", count: "415", desc: "限流、封号与矩阵清理" },
  { id: 6, name: "团队内讧", icon: "ri-team-line", count: "603", desc: "分成、解约与合约纠纷" },
];

export interface TimelineItem {
  id: number;
  date: string;
  tag: string;
  title: string;
  desc: string;
}

export const timelineItems: TimelineItem[] = [
  {
    id: 1,
    date: "09-11",
    tag: "直播事故",
    title: "夜航船阿泽 · 口播事故",
    desc: "当晚直播切片扩散，团队凌晨发布文字回应，事件进入各方解读阶段。",
  },
  {
    id: 2,
    date: "09-09",
    tag: "数据注水",
    title: "甜心苏打 · 专场曲线被拆解",
    desc: "第三方拆解贴出现，品牌方陆续下架联名入口，未发布正式说明。",
  },
  {
    id: 3,
    date: "09-06",
    tag: "粉丝互撕",
    title: "桃子不吃桃 × 一只椰子",
    desc: "一条疑似内涵文案引发两家粉丝接力刷屏，相关话题冲上热榜。",
  },
  {
    id: 4,
    date: "09-03",
    tag: "账号封禁",
    title: "冷面阿哲 · 矩阵号被限制推荐",
    desc: "粉丝发现小号无法被搜索，主页作品统一转为仅粉丝可见。",
  },
  {
    id: 5,
    date: "08-30",
    tag: "剪辑造假",
    title: "大熊拆机 · 对比视频时间轴错位",
    desc: "逐帧比对指出样机批次不一致，原视频下架并置顶说明。",
  },
  {
    id: 6,
    date: "08-26",
    tag: "深夜致歉",
    title: "铁头阿强 · 训练营宣传争议",
    desc: "发布长文承认数据引用不严谨，给出退费与补偿方案。",
  },
];

export interface RankItem {
  id: number;
  title: string;
  tag: string;
  heat: number;
  trend: "up" | "down" | "flat";
  delta: string;
}

export const rankDaily: RankItem[] = [
  { id: 1, title: "夜航船阿泽口播事故全网时间线整理", tag: "直播事故", heat: 98, trend: "up", delta: "+42%" },
  { id: 2, title: "桃子不吃桃与一只椰子粉丝团战复盘", tag: "粉丝互撕", heat: 93, trend: "up", delta: "+31%" },
  { id: 3, title: "甜心苏打专场数据曲线逐条拆解", tag: "数据注水", heat: 88, trend: "up", delta: "+24%" },
  { id: 4, title: "老K说车测评用词争议后续合集", tag: "言论争议", heat: 81, trend: "down", delta: "-6%" },
  { id: 5, title: "咸鱼小满与前运营的分成时间线", tag: "团队内讧", heat: 76, trend: "up", delta: "+18%" },
  { id: 6, title: "大熊拆机对比视频逐帧比对记录", tag: "剪辑造假", heat: 71, trend: "flat", delta: "持平" },
  { id: 7, title: "冷面阿哲矩阵号被限制推荐观察", tag: "账号封禁", heat: 64, trend: "up", delta: "+12%" },
  { id: 8, title: "楠风摄影联名周边色差争议", tag: "联名翻车", heat: 58, trend: "down", delta: "-9%" },
  { id: 9, title: "铁头阿强训练营退费细则追踪", tag: "深夜致歉", heat: 52, trend: "up", delta: "+8%" },
  { id: 10, title: "本周被翻出的三条旧切片", tag: "考古", heat: 45, trend: "flat", delta: "持平" },
];

export const rankWeekly: RankItem[] = [
  { id: 1, title: "夜航船阿泽 · 从直播切片到深夜声明全记录", tag: "直播事故", heat: 99, trend: "up", delta: "+68%" },
  { id: 2, title: "甜心苏打联名被撤，品牌方动作全梳理", tag: "数据注水", heat: 91, trend: "up", delta: "+37%" },
  { id: 3, title: "桃子不吃桃粉丝团战一周舆情曲线", tag: "粉丝互撕", heat: 86, trend: "up", delta: "+29%" },
  { id: 4, title: "大熊拆机素材管理失误说明了什么", tag: "剪辑造假", heat: 78, trend: "up", delta: "+21%" },
  { id: 5, title: "咸鱼小满合约纠纷双方声明对照", tag: "团队内讧", heat: 73, trend: "flat", delta: "持平" },
  { id: 6, title: "铁头阿强退费方案落地进度", tag: "深夜致歉", heat: 67, trend: "down", delta: "-4%" },
  { id: 7, title: "冷面阿哲矩阵号状态更新", tag: "账号封禁", heat: 61, trend: "up", delta: "+11%" },
  { id: 8, title: "老K说车测评争议同行回应汇总", tag: "言论争议", heat: 55, trend: "down", delta: "-8%" },
  { id: 9, title: "楠风摄影换货通道拥挤记录", tag: "联名翻车", heat: 49, trend: "flat", delta: "持平" },
  { id: 10, title: "本周新增待核实线索清单", tag: "线索", heat: 41, trend: "up", delta: "+6%" },
];

export interface InfluencerItem {
  id: number;
  name: string;
  handle: string;
  platform: string;
  icon: string;
  cases: number;
  followers: string;
  tag: string;
  note: string;
}

export const influencers: InfluencerItem[] = [
  {
    id: 1,
    name: "夜航船阿泽",
    handle: "@yehangchuan_aze",
    platform: "直播",
    icon: "ri-live-line",
    cases: 12,
    followers: "612万",
    tag: "高热度",
    note: "近 7 天新增 4 条相关讨论，以口播事故为主。",
  },
  {
    id: 2,
    name: "甜心苏打",
    handle: "@sweety_soda",
    platform: "带货",
    icon: "ri-shopping-bag-3-line",
    cases: 9,
    followers: "438万",
    tag: "数据争议",
    note: "专场数据被持续拆解，品牌合作动态待观察。",
  },
  {
    id: 3,
    name: "桃子不吃桃",
    handle: "@peach_no_peach",
    platform: "穿搭",
    icon: "ri-shirt-line",
    cases: 7,
    followers: "356万",
    tag: "粉丝团战",
    note: "与同赛道博主粉丝摩擦频繁，话题度高。",
  },
  {
    id: 4,
    name: "一只椰子",
    handle: "@one_coconut",
    platform: "生活",
    icon: "ri-plant-line",
    cases: 6,
    followers: "289万",
    tag: "粉丝团战",
    note: "内容风格偏日常，近期因互动争议进入榜单。",
  },
  {
    id: 5,
    name: "老K说车",
    handle: "@laok_car",
    platform: "汽车",
    icon: "ri-roadster-line",
    cases: 5,
    followers: "521万",
    tag: "言论争议",
    note: "测评用词多次引发同行讨论，回应节奏偏慢。",
  },
  {
    id: 6,
    name: "大熊拆机",
    handle: "@bigbear_teardown",
    platform: "数码",
    icon: "ri-cpu-line",
    cases: 4,
    followers: "398万",
    tag: "素材争议",
    note: "因对比素材批次问题下架视频，已置顶说明。",
  },
  {
    id: 7,
    name: "咸鱼小满",
    handle: "@salty_xiaoman",
    platform: "美食",
    icon: "ri-restaurant-2-line",
    cases: 3,
    followers: "246万",
    tag: "合约纠纷",
    note: "与前运营的分成争议交由法务处理，进展待更新。",
  },
  {
    id: 8,
    name: "铁头阿强",
    handle: "@tietou_aqiang",
    platform: "健身",
    icon: "ri-boxing-line",
    cases: 3,
    followers: "187万",
    tag: "宣传争议",
    note: "训练营宣传数据引质疑，已公布退费补偿方案。",
  },
];

export interface ThreadItem {
  id: number;
  author: string;
  avatarIcon: string;
  title: string;
  excerpt: string;
  tag: string;
  replies: number;
  likes: number;
  time: string;
  thumb: string;
}

export const threads: ThreadItem[] = [
  {
    id: 1,
    author: "列表里的旁观者",
    avatarIcon: "ri-user-3-line",
    title: "把夜航船阿泽当晚的四段切片按时间排一下，你们看对不对",
    excerpt:
      "我按直播回放的时间戳重新排了一遍，发现口播稿版本和导播切换对不上，第 3 段和第 4 段之间其实还有一段没被剪进去……",
    tag: "直播事故",
    replies: 218,
    likes: 1046,
    time: "32 分钟前",
    thumb:
      "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20a%20timeline%20made%20of%20small%20paper%20cards%20pinned%20on%20a%20warm%20cork%20board%20with%20red%20thread%20links%2C%20soft%20side%20light%2C%20muted%20cream%20and%20charcoal%20tones%2C%20minimal%20clean%20composition%2C%20no%20readable%20text%2C%20no%20people&width=240&height=240&seq=hll-thread-01&orientation=squarish",
  },
  {
    id: 2,
    author: "拆解一下",
    avatarIcon: "ri-user-2-line",
    title: "甜心苏打的三场专场，重合下单占比到底怎么算的？",
    excerpt:
      "截图里那条曲线其实可以用重复订单解释，不一定就是注水。我把公式列出来了，欢迎来挑错，别上来就扣帽子。",
    tag: "数据注水",
    replies: 164,
    likes: 782,
    time: "1 小时前",
    thumb:
      "https://readdy.ai/api/search-image?query=Editorial%20photograph%20of%20handwritten%20calculation%20notes%20and%20a%20calculator%20on%20a%20warm%20beige%20desk%2C%20soft%20window%20light%2C%20muted%20earthy%20palette%2C%20shallow%20depth%20of%20field%2C%20clean%20minimal%20composition%2C%20no%20readable%20text%2C%20no%20people&width=240&height=240&seq=hll-thread-02&orientation=squarish",
  },
  {
    id: 3,
    author: "路过看热闹",
    avatarIcon: "ri-user-smile-line",
    title: "两家粉丝这次是真的较上劲了，前排已经失控",
    excerpt:
      "本来只是一条内涵文案，现在已经发展到逐帧解读去年的合作片段了。建议都冷静一下，当事人一句话都没说呢。",
    tag: "粉丝互撕",
    replies: 402,
    likes: 1533,
    time: "2 小时前",
    thumb:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20photograph%20of%20two%20rows%20of%20small%20wooden%20speech%20bubbles%20facing%20each%20other%20on%20a%20warm%20paper%20background%2C%20soft%20directional%20light%2C%20muted%20amber%20and%20charcoal%20tones%2C%20minimal%20clean%20composition%2C%20no%20text%2C%20no%20people&width=240&height=240&seq=hll-thread-03&orientation=squarish",
  },
  {
    id: 4,
    author: "只看实锤",
    avatarIcon: "ri-shield-check-line",
    title: "大熊拆机那个批次问题，其实去年就有过一次",
    excerpt:
      "翻了一下旧视频，去年同款对比也用过不同批次，当时评论区就有人问过，只是没扩散。这次算是把老问题翻出来了。",
    tag: "剪辑造假",
    replies: 97,
    likes: 604,
    time: "4 小时前",
    thumb: "",
  },
  {
    id: 5,
    author: "不想上班",
    avatarIcon: "ri-user-4-line",
    title: "铁头阿强的退费细则出了吗？蹲一个更新",
    excerpt:
      "长文我看了三遍，只有方向没有细则，客服也排队。有没有已经走完流程的来报个进度，方便大家参考。",
    tag: "深夜致歉",
    replies: 128,
    likes: 431,
    time: "6 小时前",
    thumb: "",
  },
  {
    id: 6,
    author: "深夜刷帖",
    avatarIcon: "ri-user-5-line",
    title: "冷面阿哲的小号真的搜不到了，是限流还是别的",
    excerpt:
      "我换了两个账号测试，搜索结果里都没有，主页入口还在但作品排序变了。有懂平台规则的来解释一下吗？",
    tag: "账号封禁",
    replies: 76,
    likes: 288,
    time: "8 小时前",
    thumb: "",
  },
];

export const heroStats: { id: number; label: string; value: string; icon: string }[] = [
  { id: 1, label: "今日新增更新", value: "128", icon: "ri-flashlight-line" },
  { id: 2, label: "在库事件", value: "4,632", icon: "ri-file-list-3-line" },
  { id: 3, label: "社区讨论帖", value: "21,904", icon: "ri-chat-3-line" },
  { id: 4, label: "已关注用户", value: "86.4万", icon: "ri-user-heart-line" },
];

export const downloadStats: { id: number; label: string; value: string }[] = [
  { id: 1, label: "客户端下载", value: "120万+" },
  { id: 2, label: "日均活跃", value: "8.6万" },
  { id: 3, label: "推送覆盖率", value: "92%" },
];